<template>
  <div class="account">
    <van-nav-bar
      title="支付账户"
      left-arrow
      fixed
      placeholder
      @click-left="$router.go(-1)"
    />
    <div class="notice">
      <i class="el-icon-bell"></i>
      <p class="notice-text">
        商品橱窗/视频/直播间推广精选联盟商品需开通以下全部账户类型
      </p>
    </div>
    <div class="main">
      <van-cell
        v-if="!form.haveJh"
        value="去开通"
        is-link
        class="cell"
        @click="onClick(1)"
      >
        <template #title>
          <el-image
            class="icon"
            :src="require('@/assets/images/simulation/icon_jh.png')"
            fit="cover"
          ></el-image>
          <span class="custom-title">聚合账户</span>
        </template>
      </van-cell>
      <van-cell v-else class="cell">
        <template #title>
          <div class="custom-title">
            <el-image
              class="icon"
              :src="require('@/assets/images/simulation/icon_jh.png')"
              fit="cover"
            ></el-image>
            <span>聚合账户</span>
            <p class="custom-t-name">{{ form.realName }}</p>
            <p class="custom-t-bankCard">银行卡：{{ form.backCardNum }}</p>
            <p class="custom-t-khh">开户行：{{ form.khh }}</p>
          </div>
        </template>
        <template #right-icon>
          <div class="custom-r">
            <p>查看 <i class="el-icon-arrow-right"></i></p>
            <p class="custom-r-status">已开通</p>
            <p class="custom-r-btn">修改</p>
          </div>
        </template>
      </van-cell>

      <van-cell
        v-if="!form.haveJh"
        value="须先开通聚合账户"
        :is-link="form.haveJh"
        class="cell"
      >
        <template #title>
          <el-image
            class="icon"
            :src="require('@/assets/images/simulation/icon_zfb.png')"
            fit="cover"
          ></el-image>
          <span class="custom-title">支付宝账户</span>
          <span class="tag">推荐</span>
        </template>
      </van-cell>

      <van-cell v-else class="cell">
        <template #title>
          <div class="custom-title">
            <el-image
              class="icon"
              :src="require('@/assets/images/simulation/icon_zfb.png')"
              fit="cover"
            ></el-image>
            <span>支付宝账户</span>
            <p class="custom-t-name">{{ form.realName }}</p>
            <p class="custom-t-bankCard">银行卡：{{ form.backCardNum }}</p>
            <p class="custom-t-khh">开户行：{{ form.khh }}</p>
          </div>
        </template>
        <template #right-icon>
          <div class="custom-r">
            <p><br /></p>
            <p class="custom-r-status">已开通</p>
            <p class="custom-r-btn">修改</p>
          </div>
        </template>
      </van-cell>

      <van-cell
        v-if="!form.haveWx"
        value="去开通"
        is-link
        class="cell"
        @click="onClick(2)"
      >
        <template #title>
          <el-image
            class="icon"
            :src="require('@/assets/images/simulation/icon_wc.png')"
            fit="cover"
          ></el-image>
          <span class="custom-title">微信账户</span>
        </template>
      </van-cell>
      <van-cell v-else class="cell">
        <template #title>
          <div class="custom-title">
            <el-image
              class="icon"
              :src="require('@/assets/images/simulation/icon_wc.png')"
              fit="cover"
            ></el-image>
            <span>微信账户</span>
            <p class="custom-t-name">{{ form.realName }}</p>
            <p class="custom-t-bankCard">银行卡：{{ form.backCardNum }}</p>
            <p class="custom-t-khh">开户行：{{ form.khh }}</p>
          </div>
        </template>
        <template #right-icon>
          <div class="custom-r">
            <p><br /></p>
            <p class="custom-r-status">已开通</p>
            <p class="custom-r-btn">修改</p>
          </div>
        </template>
      </van-cell>

      <van-cell
        v-if="!form.haveJh"
        value="须先开通聚合账户"
        :is-link="form.haveJh"
        class="cell"
      >
        <template #title>
          <el-image
            class="icon"
            :src="require('@/assets/images/simulation/icon_hz.png')"
            fit="cover"
          ></el-image>
          <span class="custom-title">合众账户</span>
        </template>
      </van-cell>
      <van-cell v-else class="cell">
        <template #title>
          <div class="custom-title">
            <el-image
              class="icon"
              :src="require('@/assets/images/simulation/icon_hz.png')"
              fit="cover"
            ></el-image>
            <span>合众账户</span>
            <p class="custom-t-name">{{ form.realName }}</p>
            <p class="custom-t-bankCard">银行卡：{{ form.backCardNum }}</p>
            <p class="custom-t-khh">开户行：{{ form.khh }}</p>
          </div>
        </template>
        <template #right-icon>
          <div class="custom-r">
            <p><br /></p>
            <p class="custom-r-status">已开通</p>
            <p class="custom-r-btn">修改</p>
          </div>
        </template>
      </van-cell>
    </div>
  </div>
</template>

<script>
import "vant/lib/index.css";
import { NavBar, Cell } from "vant";
export default {
  props: {
    form: Object,
  },
  components: {
    [NavBar.name]: NavBar,
    [Cell.name]: Cell,
  },
  methods: {
    onClick(type) {
      this.$router.push(`/simulation/douyinchuchuang/fillAccount?type=${type}`);
    },
  },
};
</script>

<style lang="less" scoped>
.account {
  .notice {
    padding: 10px;
    font-size: 12px;
    color: #f8aa00;
    background-color: #fffbdb;
    .el-icon-bell {
      margin-right: 10px;
      font-size: 16px;
      font-weight: bold;
    }
    .notice-text {
      display: inline-block;
      width: 90%;
      vertical-align: top;
    }
  }
  .main {
    ::v-deep .cell {
      margin-bottom: 10px;
      padding-left: 10px;
      padding-right: 10px;
      .icon {
        margin-right: 10px;
        vertical-align: middle;
      }
      .tag {
        margin-left: 10px;
        padding: 2px 5px;
        color: #909399;
        font-size: 12px;
        border: solid 1px #e4e7ed;
      }
      .custom-title {
        .custom-t-name,
        .custom-t-bankCard,
        .custom-t-khh {
          padding-left: 32px;
          font-size: 12px;
          &.custom-t-name {
            margin-top: 10px;
          }
          &.custom-t-bankCard,
          &.custom-t-khh {
            color: #909399;
          }
        }
      }
      .custom-r {
        text-align: right;
        .custom-r-status {
          padding: 10px 0;
          font-size: 12px;
          color: #909399;
        }
        .custom-r-btn {
          margin-top: 8px;
          padding: 1px 16px;
          text-align: center;
          border: solid 1px #909399;
        }
      }
    }
  }
}
</style>